module.exports = __webpack_public_path__ + "img/asia-admin05.ed418040.png";